import { defaultLocale } from "@mw/shared/i18n";
import { useLocale } from "next-intl";

export const useLocalePrefix = () => {
  const locale = useLocale();
  return locale === defaultLocale ? "" : `/${locale}`;
};
